import SquiggleAccent from './SquiggleAccent'
import type { ReactNode } from 'react'
import Reveal from '@/components/preview/Reveal'

export default function SectionHeader({
  eyebrow,
  title,
  accent,
  description,
  action,
  tone = 'light',
}: {
  eyebrow: string
  title: string
  accent?: string
  description?: ReactNode
  action?: ReactNode
  tone?: 'light' | 'dark'
}) {
  const dark = tone === 'dark'

  return (
    <Reveal>
      <p
        className={`preview-mono mb-8 flex items-center justify-between text-[10px] font-bold uppercase tracking-[0.24em] ${dark ? 'text-sage-200' : 'text-muted'}`}
      >
        <span>{eyebrow}</span>
        <span className={dark ? '' : 'text-forest'}>+</span>
      </p>
      <div className="grid gap-6 sm:grid-cols-[minmax(0,1fr)_auto] sm:items-end">
        <div>
          <h2 className="max-w-3xl font-heading text-5xl leading-[0.95] tracking-[-0.04em] sm:text-7xl">
            {title}{' '}
            {accent && (
              <SquiggleAccent
                className={dark ? 'text-sage-200' : 'text-forest'}
              >
                {accent}
              </SquiggleAccent>
            )}
          </h2>
          {description && (
            <div
              className={`mt-6 max-w-2xl text-sm leading-7 sm:text-base sm:leading-8 ${dark ? 'text-cream-50/85' : 'text-ink-soft'}`}
            >
              {description}
            </div>
          )}
        </div>
        {action}
      </div>
    </Reveal>
  )
}
